<div class="lab-broker">
	<div class="lab-broker__loading" *ngIf="isLoading$ | async">
		<tlk-loading-spinner></tlk-loading-spinner>
	</div>

	<iframe
		#iframeRef
		title="Lab broker 3rd-party app"
		class="lab-broker__iframe"
		[src]="safeUrl"
		sandbox="allow-scripts allow-same-origin allow-forms"
	></iframe>
</div>
